import style from "./Input.module.scss";

interface InputProps {
  placeholder: string;
  value: string;
  onChangeFunc: (value: string) => void;
  disabled?: boolean;
  onBlur?: () => void;
  isDark?: boolean;
  id: string;
  isTel?: boolean;
}

export default function Input({
  placeholder,
  value,
  onChangeFunc,
  disabled = false,
  onBlur,
  isDark = false,
  id = "input",
  isTel = false
}: InputProps) {
  return (
    <input
      type={isTel ? "tel" : "text"}
      placeholder={placeholder}
      className={ `${isDark ? style.Input__Field_Dark : style.Input__FieldFont}`}
      value={value}
      onChange={(e) => onChangeFunc(e.target.value)}
      disabled={disabled}
      onBlur={onBlur}
      id={id}
    />
  );
}